"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyLinkIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CopyLink_svg_1 = __importDefault(require("./CopyLink.svg"));
/**
 * Copy link icon
 * figma link - https://www.figma.com/file/UpS0VG7yUnr0VLopn0wBwx/Sharing-component?node-id=5004%3A12689
 */
function CopyLinkIcon() {
    // todo: use sds alternative
    return (0, jsx_runtime_1.jsx)(CopyLink_svg_1.default, {});
}
exports.CopyLinkIcon = CopyLinkIcon;
//# sourceMappingURL=CopyLinkIcon.js.map